
<div class="modal-dialog modal-lg">
  <div class="modal-content p-3">
    <div class="modal-body">
      <error [error]="error"></error>
    </div>
    <div class="modal-header border-bottom-0">
      <h5 class="modal-title text-secondary">{{title}}</h5>
      <button class="close" type="button" (click)="close()">&times;</button>
    </div>
    <div class="modal-body container-fluid">
      <div class="row">
        <div class="col-md-6">
          <select class="form-control" [(ngModel)]="selectedShippingDestination" (change)="form.reset()">
            <option *ngFor="let shippingDestination of shippingDestinationValues" [ngValue]="shippingDestination[0]">{{ shippingDestination[1] }}</option>
          </select>
        </div>
        <div class="col-md-6 d-flex justify-content-end" *ngIf="selectedShippingDestination !== 'STAGING_WAREHOUSE'">
          <button class="btn btn-outline-secondary" type="button" style="width: 130px" (click)="close()">Cancel</button>
          <button class="btn btn-outline-primary ml-2" type="button" style="width: 130px" (click)="save()">Save</button>
        </div>
      </div>
      <div class="row mt-3 mb-0" *ngIf="form.invalid &amp;&amp; form.touched">
        <div class="col-12">
          <div class="alert alert-danger mb-0">You have to select a warehouse.</div>
        </div>
      </div>
      <ng-template [ngIf]="selectedShippingDestination === 'STAGING_WAREHOUSE'">
        <hr>
        <div class="row pt-2">
          <div class="col-12">
            <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" [defaultPageListSize]="1" (onChange)="onListControlsChange($event)"></list-controls>
          </div>
        </div>
        <hr>
        <form [formGroup]="form" (ngSubmit)="save()">
          <div class="row">
            <div class="col-12" style="overflow-x: auto;">
              <div class="table-responsive spreadsheet-container">
                <table class="table table-bordered">
                  <thead>
                    <tr class="tr-header-edit-asset">
                      <th class="border-right-0">&nbsp;</th>
                      <th class="border-left-0">Staging Partner</th>
                      <th>Country</th>
                      <th>City</th>
                      <th>Region</th>
                      <th>Region</th>
                      <th>Address</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-template [ngIf]="loading">
                      <tr>
                        <td colspan="7">
                          <md-spinner-block></md-spinner-block>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template [ngIf]="!loading">
                      <tr *ngFor="let warehouse of warehouses" style="font-size: 0.85rem">
                        <td class="border-right-0">
                          <input type="radio" formControlName="warehouseId" [value]="warehouse.stagingWarehouseId">
                        </td>
                        <td class="border-left-0">{{warehouse.name}}</td>
                        <td>{{warehouse.address.country}}</td>
                        <td>{{warehouse.address.city}}</td>
                        <td>{{warehouse.address.region}}</td>
                        <td>{{warehouse.address.regionAbbreviation}}</td>
                        <td>{{warehouse.address.line1}}</td>
                      </tr>
                    </ng-template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-end border-top-0 pr-0">
            <button class="btn btn-outline-secondary" type="button" style="width: 130px" (click)="close()">Cancel</button>
            <button class="btn btn-outline-primary ml-2" type="submit" style="width: 130px">Save</button>
          </div>
        </form>
      </ng-template>
    </div>
  </div>
</div>